<template>
    <div>
        <Head title="Місця для рибалки"/>
        <h1 class="mb-8 text-3xl font-bold">Місця для рибалки</h1>
        <div class="flex items-center justify-between mb-6">
            <div class="flex items-center gap-3 mr-4">
                <select
                    v-model="form.lake_id"
                    class="form-select w-56"
                >
                    <option :value="null">Всі озера</option>
                    <option v-for="lake in lakes" :key="lake.id" :value="lake.id">
                        {{ lake.name }}
                    </option>
                </select>
                <button
                    v-if="form.lake_id"
                    type="button"
                    class="text-sm text-gray-500 hover:text-gray-700"
                    @click="reset"
                >
                    Скинути
                </button>
            </div>
            <Link
                class="btn-indigo"
                :href="$route('points.create')"
            >
                <span>Створити</span>
                <span class="hidden md:inline"> місце для рибалки</span>
            </Link>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Назва</th>
                    <th class="pb-4 pt-6 px-6">Широта:Довгота</th>
                    <th class="pb-4 pt-6 px-6">Озеро</th>
                    <th class="pb-4 pt-6 px-6">Номер місця</th>
                </tr>
                <tr v-for="point in points.data" :key="points.id"
                    class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="$route('points.edit', point.id)">
                            {{ point.name }}
                            <icon v-if="point.deleted_at" name="trash"
                                  class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400"/>
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4"
                            :href="$route('points.edit', point.id)"
                            tabindex="-1"
                        >
                            {{ point.latitude }} : {{ point.longitude }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4"
                            :href="$route('points.edit', point.id)"
                            tabindex="-1"
                        >
                            {{ point.lake_name }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4"
                            :href="$route('points.edit', point.id)"
                            tabindex="-1"
                        >
                            {{ point.number }}
                        </Link>
                    </td>
                    <td class="w-px border-t">
                        <Link
                            class="flex items-center px-6 py-4"
                            :href="$route('points.edit', point.id)"
                            tabindex="-1"
                        >
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
                        </Link>
                    </td>
                </tr>
                <tr v-if="points.data.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">Немає жодного запису</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="points.links"/>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
    },
    layout: Layout,
    props: {
        filters: Object,
        lakes: Array,
        points: Object,
    },
    data() {
        return {
            form: {
                lake_id: this.filters.lake_id ?? null,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(this.$route('points.index'), pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form.lake_id = null
        },
    },
}
</script>
